import { Box } from '@mui/material'
import { useRecordContext } from 'react-admin'

import AutonomyField from './AutonomyField'
import Battery12VField from './Battery12VField'
import EngineField from './EngineField'
import LockStatusField from './LockStatusField'
import MileageField from './MileageField'
import SpeedField from './SpeedField'

const VehicleStateSection = () => {
  const record = useRecordContext()

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: 'repeat(2, 1fr)',
        columnGap: 1.5,
        rowGap: 0.25,
        alignItems: 'center',
        justifyItems: 'start',
      }}
    >
      <SpeedField max_speed={record.max_speed} />
      <LockStatusField isLocked={record.locked} />

      <EngineField engine_running={record.engine_running} rpm={record.extra_data?.engine_rpm} />
      <AutonomyField />
      {record?.battery_voltage != null && <Battery12VField />}
      <MileageField />
    </Box>
  )
}

export default VehicleStateSection
